import {axiosInstance} from "../instance";

const AsphaltList = (data) => {
    return axiosInstance
        .post('/api/asphalt-price-list', data);
}

const AsphaltUpdate = (asphalt) => {
    return axiosInstance
        .post('/api/asphalt-price', asphalt);
}

const AsphaltDelete = (id) => {
    return axiosInstance
        .delete('/api/asphalt-price/' + id);
}

export {AsphaltList, AsphaltUpdate, AsphaltDelete};
